//npm packages
import React, { memo } from 'react';
import { useHistory } from 'react-router-dom';
import { shallowEqual, useSelector } from 'react-redux';
import { faHistory } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from 'reactstrap';

//redux actions
import { equipmentList } from '../../redux/actions';

//elements starts with capital letter
import { GridBase } from '../../components';

//helper files
import strings from '../../globalization';

const EquipmentList = memo(props => {
  const history = useHistory();

  const handleAdd = props => {
    const { parentId } = props;
    history.push({ pathname: `/equipment/new/${parentId}` });
  };

  const onHistory = ({ row }) => {
    return (
      <div>
        <Button
          size="sm"
          color="primary"
          className="commandBtn"
          onClick={() =>
            history.push({ pathname: `/history/${row._id}`, skip: true })
          }
        >
          <FontAwesomeIcon icon={faHistory} /> {strings.History}
        </Button>
      </div>
    );
  };

  const { initialValues } = useSelector(({ licenseFormData }) => {
    return { initialValues: licenseFormData.data.data || {} };
  }, shallowEqual);
  const columns = [
    { key: 'UniqueKey', name: strings.UniqueId, width: 150, type: 'number' },
    { key: 'SerialNumber', name: strings.SerialNo, width: 150 },
    {
      key: 'EquipmentType',
      name: strings.EquipmentType,
      width: 150,
      mode: 'remote',
      store: 'EquipmentType',
      valueProp: 'Name',
      displayValue: 'Name'
    },
    {
      key: 'ModelName',
      name: strings.EquipmentModel,
      width: 150,
      mode: 'remote',
      store: 'EquipmentModel',
      valueProp: 'ModelName',
      displayValue: 'ModelName'
    },
    {
      key: 'Notes',
      name: strings.Notes,
      width: 150
    },
    {
      key: 'EquipmentStateName',
      name: strings.EquipmentState,
      width: 150,
      mode: 'remote',
      store: 'EquipmentState',
      valueProp: 'DisplayValue',
      displayValue: 'DisplayValue'
    },
    {
      key: 'DateDeactivated',
      name: strings.DateDeactivated,
      type: 'date',
      hidden: false,
      width: 140
    },
    {
      key: 'createdAt',
      name: strings.CreatedOn,
      type: 'datetime-local',
      renderer: 'date-time',
      hidden: false,
      width: 120
    },
    {
      key: 'updatedAt',
      name: strings.updatedAt,
      type: 'datetime-local',
      renderer: 'date-time',
      hidden: false,
      width: 120
    },
    {
      key: 'CreatedByName',
      name: strings.CreatedBy,
      hidden: false,
      width: 150,
      mode: 'remote',
      store: 'User',
      valueProp: 'UserName',
      displayValue: 'UserName'
    },
    {
      key: 'ModifiedByName',
      name: strings.UpdatedBy,
      hidden: false,
      width: 150,
      mode: 'remote',
      store: 'User',
      valueProp: 'UserName',
      displayValue: 'UserName'
    },
    {
      key: 'Actions',
      type: 'action',
      name: strings.History,
      getRowMetaData: row => row,
      formatter: onHistory,
      width: 150
    }
  ];
  return (
    <GridBase
      {...props}
      key={Math.random()}
      columns={columns}
      action={equipmentList}
      title={strings.Equipment}
      disableFilter={false}
      disableAdd={
        props.disableAdd ||
        initialValues.isCatSyncOnly ||
        initialValues.isCatEdgeOnly ||
        initialValues.isCatSyncEdgeOnly
      }
      disableShowHideColumns={false}
      dataProperty="equipmentListData"
      parentRoute="equipment"
      comboType={[
        'EquipmentType',
        'ConnectivityType',
        'EquipmentModel',
        'TransferPDF',
        'EquipmentState',
        'User',
        'Preference'
      ]}
      handleAdd={handleAdd}
      loadPref={true}
      listId="Equipment"
    />
  );
});

export default EquipmentList;
